import { Outlet, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { MetaPixel } from "@/lib/meta";

export default function SiteLayout() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  useEffect(() => { if (ref) localStorage.setItem("safarshala_ref", ref.toUpperCase()); }, [ref]);
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <MetaPixel />
    </div>
  );
}
